import { useCallback, type FC } from 'preact/compat';

import { EllipsisText, SimpleCell } from '@vkontakte/vkui';

import { getFileIcon, getFileType } from '../../utils';

import { downloadFileApi } from '../../api/downloadFileApi';

import styles from './styles.module.css';

interface Props {
  className?: string;
  contentType: string;
  fileName: string;
  url: string | null;
}

export const FileItem: FC<Props> = ({ className, fileName, contentType, url }) => {
  const fileType = getFileType(contentType);
  const fileIcon = getFileIcon(fileType, 20);

  const handleClick = useCallback(() => {
    if (url) {
      downloadFileApi(url, fileName);
    }
  }, [fileName, url]);

  return (
    <SimpleCell className={className} before={<div className={styles.iconWrap}>{fileIcon}</div>} onClick={handleClick}>
      <EllipsisText>{fileName}</EllipsisText>
    </SimpleCell>
  );
};
